import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "@mui/material";
import { HttpService } from "../../service/HttpService";
import PlantMapping from "../PlantMapping/PlantMapping";
import FertigationHistory from "../Fertigation/FertigationHistory/FertigationHistory";
import RoomLogMasterTable from "../../components/RoomLogMaster/RoomLogMasterTable";
import HarvestArchive from "../Harvest/HarvestArchive";
import DryRoom from "../DryRoom/DryRoom";

const RoomTabs = () => {
  const [roomTab, setRoomTab] = useState(0);
  const [contentTab, setContentTab] = useState(0);
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(false);

  const httpService = new HttpService();

  const fetchRooms = async () => {
    setLoading(true);
    try {
      const res = await httpService.get("rooms?sortBy=name&sortOrder=ASC");
      const roomsData = res?.data?.data || [];
      // industry-standard: configurable special rooms
      const EXTRA_ROOMS = ["clone room", "mom room"];
      const filteredRooms = roomsData
        // .filter(
        //   (room) => room.name && /^room\s([1-9][0-9]?)$/i.test(room.name.trim())
        // )
        .filter((room) => {
          if (!room.name) return false;

          const name = room.name.trim().toLowerCase();

          // existing logic (unchanged)
          const isNumberedRoom = /^room\s([1-9][0-9]?)$/.test(name);

          // minimal addition
          const isExtraRoom = EXTRA_ROOMS.includes(name);

          return isNumberedRoom || isExtraRoom;
        })
        // .sort((a, b) => {
        //   const numA = parseInt(a.name.match(/\d+/)?.[0] || 0, 10);
        //   const numB = parseInt(b.name.match(/\d+/)?.[0] || 0, 10);
        //   return numA - numB;
        // });
        .sort((a, b) => {
          const getNumber = (name) => {
            const match = name.match(/\d+/);
            return match ? Number(match[0]) : Infinity;
          };

          return getNumber(a.name) - getNumber(b.name);
        });

      setRooms(filteredRooms);
    } catch (e) {
      console.error("Error fetching rooms:", e);
      setRooms([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchRooms();
  }, []);

  const tabsSx = {
    backgroundColor: "#fffffc",
    "& .MuiTabs-indicator": {
      backgroundColor: "#00A272",
      height: "3px",
    },
    "& .MuiTab-root": {
      position: "relative",
      color: "#A1A2A1",
      fontWeight: 400,
      fontSize: "16px",
      textTransform: "none",
      padding: "12px 20px",
      marginRight: "8px",
      "&:not(.Mui-selected)::after": {
        content: '""',
        position: "absolute",
        left: 0,
        right: 0,
        bottom: 0,
        height: "3px",
        backgroundColor: "#C4C4C4",
      },
      "&.Mui-selected": {
        color: "#00A272 !important",
        fontWeight: 600,
        backgroundColor: "#E6F6F1",
        borderRadius: "4px 4px 0 0",
      },
    },
  };

  return (
    <div className="company">
      <div className="page-title">
        <div className="title-wrap">
          <h1>Room Log History</h1>
        </div>
      </div>

      <div className="common_content">
        <Tabs
          value={roomTab}
          onChange={(e, newValue) => setRoomTab(newValue)}
          variant="scrollable"
          scrollButtons={false}
          sx={{ ...tabsSx, mb: 2 }}
        >
          {rooms.map((room) => (
            <Tab key={room.id} label={room.name} />
          ))}
        </Tabs>

        <Tabs
          value={contentTab}
          onChange={(e, newValue) => setContentTab(newValue)}
          variant="scrollable"
          scrollButtons={false}
          sx={{ ...tabsSx, mb: 3 }}
        >
          <Tab label="Planting" />
          <Tab label="Fertigation" />
          <Tab label="Room Log" />
          <Tab label="Dry Room" />
          {/* <Tab label="Harvest Archive" /> */}
        </Tabs>

        {contentTab === 0 && rooms[roomTab] && (
          <PlantMapping
            key={`planting-${roomTab}`}
            roomId={rooms[roomTab]?.id}
          />
        )}
        {contentTab === 1 && rooms[roomTab] && (
          <FertigationHistory
            key={`fertigation-${roomTab}`}
            roomId={rooms[roomTab]?.id}
          />
        )}
        {contentTab === 2 && rooms[roomTab] && (
          <RoomLogMasterTable
            key={`roomlog-${roomTab}`}
            loading={loading}
            roomId={rooms[roomTab]?.id}
          />
        )}
        {contentTab === 3 && rooms[roomTab] && (
          <DryRoom key={`dryroom-${roomTab}`} roomId={rooms[roomTab]?.id} />
        )}
        {/* {contentTab === 4 && rooms[roomTab] && (
          <HarvestArchive key={`harvest-archive-${roomTab}`} />
        )} */}
      </div>
    </div>
  );
};

export default RoomTabs;
